import { notification } from "antd";
import dayjs from "dayjs";

export const showToast = (msg?: string, desc?: string, type?: string) => {
  if (type == "success") {
    notification.success({
      message: msg,
      description: desc,
    });
  } else {
    notification.error({
      message: msg,
      description: desc,
    });
  }
};

export const makeFormData = (obj: any) => {
  const formData = new FormData();

  Object.entries(obj).forEach(([key, value]: any) => {
    formData.append(`${key}`, value);
  });

  return formData;
};

export const handleApiCatch = (err?: any) => {
  console.log(err, "<====err");
  showToast("Error", "Internal Server Error!");
};

export const areArraysEqual = (arr1: any[], arr2: any[]) => JSON.stringify(arr1) === JSON.stringify(arr2);

export const displayValueOrNA = (value: any) => {
  const isBlankArray = Array.isArray(value) && value.length === 0;
  return value && !isBlankArray ? value : "NA";
};
export function formatUtcToLocal(dateString?: string | null): {
  date: string;
  time: string;
} {
  if (!dateString) return { date: "", time: "" };

  const localDate = dayjs.utc(dateString).local();
  return {
    date: localDate.format("DD/MM/YYYY"),
    time: localDate.format("HH:mm:ss"),
  };
}
export const formatDateTime = (input: string) => {
  const date = new Date(input);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // convert 0 or 24 hour format to 12-hour

  return `${day}/${month}/${year} - ${hours}:${minutes} ${ampm}`;
};
export const formatDate = (input: string) => {
  const date = new Date(input);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};
